import { Store } from "utilities/Redux/store"

export const getSessionId = (state: Store) => state.stripe.sessionId
